var map = {
	"./action_shap.png": 75875,
	"./author_img.png": 59027,
	"./banner_bg.png": 5592,
	"./banner_bg_2.png": 93531,
	"./banner_img.png": 30364,
	"./divider.png": 71139,
	"./dot.png": 60937,
	"./icon01.png": 91812,
	"./icon02.png": 5375,
	"./icon3.png": 43442,
	"./icon_04.png": 40898,
	"./icon_05.png": 4555,
	"./icon_shape1.png": 37714,
	"./icon_shape2.png": 68681,
	"./icon_shape3.png": 90560,
	"./icon_shape4.png": 25535,
	"./instagram.png": 74068,
	"./linkedin.png": 34480,
	"./process_1.png": 5071,
	"./process_2.png": 82612,
	"./process_3.png": 3741,
	"./process_4.png": 10946,
	"./process_5.png": 74603,
	"./shape.png": 10431,
	"./team1.jpg": 46196,
	"./team2.jpg": 75907,
	"./tiktok.png": 55628,
	"./twitter.png": 94953,
	"./work1.png": 71924,
	"./work2.png": 46415,
	"./work3.png": 23750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79048;